module.exports = __webpack_public_path__ + "images/placeholder-project-statistic-thumb-f25a11b417b0efe5230149d97b7838bc.png";